<template>
	<div class="answer">
		<div class="contetn">
			<div class="text">
				<div>下方可查看您的考题及对应答案。</div>
				<div>您也可查看题库中其他14套题目及</div>
				<div>其对应答案，便于您拓展学习。</div>
			</div>
		</div>
		<div class="footer">
			<div @click="handleBtn(true)" class="footerBox">您的考题及对应答案</div>
			<div @click="handleBtn(false)" class="footerBox">其他考题及对应答案</div>
		</div>
	</div>
</template>

<script>
	import {
		getPaperAndAnswer
	} from "@/api/system/exam";

	export default {
		data() {
			return {};
		},
		created() {},
		methods: {
			handleBtn(val) {
				if (val) {
					getPaperAndAnswer().then((res) => {
						if (res.data.code === 0) {
							this.$router.push({
								path: "/treat/pdf",
								query: {
									url: res.data.data[0].answer
								},
							});
						}
					});
				} else {
					this.$router.push({
						path: "/treat/other",
						query: {
							flag: 2
						},
					});
				}
			},
		},
	};
</script>

<style lang="less" scoped>
	.answer {
		width: 100%;
		min-height: 100vh;
		background-image: url("./../../assets/home/cbbj.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
		display: flex;
		flex-direction: column;
		align-items: center;

		.contetn {
			width: 653px;
			height: 391px;
			background: rgba(255, 255, 255, 0.85);
			border: 2px solid #ffffff;
			border-radius: 60px;
			margin-top: 190px;
			font-size: 35px;
			font-weight: 500;
			color: #4c4c4c;
			display: flex;
			align-items: center;
			justify-content: center;

			.text {
				line-height: 60px;
			}
		}

		.footer {
			margin-top: 134px;

			.footerBox {
				width: 497px;
				height: 101px;
				line-height: 101px;
				text-align: center;
				font-size: 35px;
				font-weight: 500;
				color: #ffffff;
				background: linear-gradient(132.74deg,
						rgba(0, 187, 177, 1) 0%,
						rgba(0, 86, 140, 1) 74.31%,
						rgba(171, 59, 127, 1) 100%);
				border: 1px solid #ffffff;
				box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
				border-radius: 50px;
			}

			.footerBox:nth-child(2) {
				margin-top: 40px;
			}
		}
	}
</style>